<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { type SpinnerVariants, spinnerVariants } from '.'

const props = defineProps<{
  size?: SpinnerVariants['size']
  overlay?: boolean
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-id="overlay"
    :class="
      cn('flex items-center justify-center', { 'absolute inset-0 z-50 bg-white/50': props.overlay })
    "
  >
    <div data-id="spinner" :class="cn(spinnerVariants({ size: props.size }), props.class)"></div>
  </div>
</template>
